import axios, {AxiosRequestConfig, AxiosResponse} from 'axios';
import {TestExecutionDto} from "../api";

export interface TestRequest {
    testId: number;
    jwtToken: string;
    withTrace: boolean;
}


export class CustomPlaywrightApi {
    private readonly baseUrl: string;

    constructor(baseUrl: string = 'http://localhost:11213') {
        this.baseUrl = baseUrl;
    }

    async executeTest(
        request: TestRequest,
        config: AxiosRequestConfig
    ): Promise<AxiosResponse<TestExecutionDto>> {
        try {
            const response: AxiosResponse<TestExecutionDto> = await axios.post(
                `${this.baseUrl}/execute/test`,
                request,
                config
            );
            return response;
        } catch (error) {
            console.error('Fehler bei executeTest:', error);
            throw error;
        }
    }

    async openCodegen(
        config: AxiosRequestConfig
    ): Promise<AxiosResponse<string>> {
        try {
            const response: AxiosResponse<string> = await axios.get(
                `${this.baseUrl}/codegen`,
                config
            );
            return response;
        } catch (error) {
            console.error('Fehler bei codegen:', error);
            throw error;
        }
    }
}